import React, { useState } from "react";
import "./EditProfileLastName.css";

const EditProfileLastName = (props) => {
  const [lastNameOne, setLastNameOne] = useState('')

  const onInputChangeTwo = (event) => {
    const lastName = event.target.value;
    setLastNameOne(lastName);
    props.getLastNameData(lastName)
  }

  const onSubmit = (event) => {
    event.preventDefault();
}

  return (
    <div className="edit-profile-last-name">
      <div className="first-name-h-eading">
        <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Last Name</div>
      </div>
      <input 
        onSubmit={onSubmit}
        className="last-name-input-field border-1px-mischka" 
        type="text" 
        value={lastNameOne}
        onChange={onInputChangeTwo} 
      />
    </div>
  );
}

export default EditProfileLastName;
